import { LucideIcon, Pencil } from 'lucide-react'
import { IncompleteBadge } from './incomplete-badge'

interface SectionHeaderProps {
  icon: LucideIcon
  title: string
  isComplete?: boolean
  showEditButton?: boolean
  onEditClick?: () => void
}

/**
 * Section header with icon, title, optional incomplete badge, and edit button
 */
export function SectionHeader({
  icon: Icon,
  title,
  isComplete = true,
  showEditButton = false,
  onEditClick,
}: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        <Icon className="w-6 h-6 text-slate-700" />
        <h2 className="text-2xl font-normal text-slate-900 tracking-tight">
          {title}
        </h2>
        {!isComplete && <IncompleteBadge />}
      </div>

      {showEditButton && (
        <button
          onClick={onEditClick}
          className="flex items-center gap-2 px-6 py-3.5 rounded-[48px] border-2 border-slate-200 bg-white text-slate-900 font-normal text-base hover:bg-slate-50 transition-colors"
        >
          <Pencil className="w-5 h-5" />
          Edit
        </button>
      )}
    </div>
  )
}
